var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgBarsOutline = function SvgBarsOutline(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90,27 L10,27 C4.5,27 0,31.05 0,36 C0,40.9499999 4.5,45 10,45 L90,45 C95.5,45 100,40.9499999 100,36 C100,31.05 95.5,27 90,27 L90,27 Z M10,18 L70,18 C75.5,18 80,13.9499999 80,9 C80,4.05 75.5,0 70,0 L10,0 C4.5,0 0,4.05 0,9 C0,13.9499999 4.5,18 10,18 Z M70,54 L10,54 C4.5,54 0,58.05 0,63 C0,67.95 4.5,72 10,72 L70,72 C75.5,72 80,67.95 80,63 C80,58.05 75.5,54 70,54 Z"
  }))))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgBarsOutline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "bars-outline.f15cf88dff935c9b6ccdff25dfb0c425.svg";